import { ExtratoDocumento, type ExtratoParaDocumento } from "@bookdental/ui";
import { competenciaAtual, hojeEmTexto } from "@bookdental/schemas";

const hoje = hojeEmTexto();
const ITENS: ExtratoParaDocumento["itens"] = [
  { id: "1", tipo: "SERVICO", pedidoId: "a", pedidoNumero: 1042, paciente: "Maria Silva", dentista: "Dra. Ana Souza", descricao: "Coroa Emax", material: "Dissilicato de lítio", dentes: "14, 15", data: hoje, quantidade: 2, valorCents: 73000 },
  { id: "2", tipo: "ACRESCIMO", pedidoId: "a", pedidoNumero: 1042, paciente: "Maria Silva", dentista: "Dra. Ana Souza", descricao: "Taxa de urgência", material: null, dentes: null, data: hoje, quantidade: 1, valorCents: 1500 },
  { id: "3", tipo: "SERVICO", pedidoId: "b", pedidoNumero: 1043, paciente: "João Pereira", dentista: "Dr. Carlos Lima", descricao: "Placa de bruxismo", material: null, dentes: "Arcada superior", data: hoje, quantidade: 1, valorCents: 20000 },
  { id: "4", tipo: "RETRABALHO", pedidoId: "c", pedidoNumero: 1031, paciente: "Ana Costa", dentista: "Dra. Ana Souza", descricao: "Refação sem custo · Placa de bruxismo", material: null, dentes: null, data: hoje, quantidade: 1, valorCents: 0 },
];

/** Como o extrato vai sair, com um exemplo e as escolhas da tela ao lado. */
export function PreviaDoExtrato({
  laboratorio,
  cabecalho,
  mostrarRefacaoGratuita,
}: {
  laboratorio: ExtratoParaDocumento["laboratorio"];
  cabecalho: ExtratoParaDocumento["cabecalho"];
  mostrarRefacaoGratuita: boolean;
}) {
  const itens = mostrarRefacaoGratuita ? ITENS : ITENS.filter((i) => i.valorCents > 0);
  return (
    <div className="max-h-[720px] overflow-auto rounded-xl border border-zinc-200 bg-white p-6 shadow-sm">
      <ExtratoDocumento
        extrato={{
          numero: 1,
          rotulo: competenciaAtual(),
          vencimento: hoje,
          status: "EMITIDO",
          destinatarioNome: "Clínica Exemplo",
          destinatarioDocumento: null,
          destinatarioEndereco: "Av. Paulista, 1000 · Bela Vista · São Paulo - SP",
          totalCents: itens.reduce((t, i) => t + i.valorCents, 0),
          cabecalho,
          laboratorio,
          itens,
        }}
      />
    </div>
  );
}
